import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import { FormationBox } from '../components/FormationBox';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    height: 300px;
    background-color: white;
    background-image: url('/assets/images/formation-banner.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 5% 15% 5% 15%;

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .menus {
      display: flex;

      > p {
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 14px;
        padding: 13px 10px;
        margin-right: 15px;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }
    }
  }

  .top-box {
    min-height: 400px;
    background-color: #e0e0e0;
    color: grey;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    padding-top: 50px;

    p {
      font-size: 16px;
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      // background-color: green;
    }
  }
`;

export const Formation = () => {
  const history = useHistory();

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <Space size={10}>
            <Image
              alt='moranje-logo'
              src='assets/images/moranje-logo.png'
              // height={250}
              width={130}
              preview={false}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
            />
            <div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 30,
                }}
              >
                Formation
              </div>
            </div>
          </Space>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <FaHome style={{ marginRight: 5 }} />
              <span>Accueil</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Formation</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

          <div className='menus'>
            {FORMATIONS.map((form, i) => (
              <p key={i} onClick={() => history.push(form.link)}>
                {form.label}
              </p>
            ))}
          </div>
        </div>
        {/* 
        <div className='top-box'>
          <div>
            <p>
              <FaSquare size={11} color={ORANGE} style={{ marginRight: 10 }} />
               ...
            </p>
            <p>
              <FaSquare size={11} color={ORANGE} style={{ marginRight: 10 }} />
               ...
            </p>
            <p>
              <FaSquare size={11} color={ORANGE} style={{ marginRight: 10 }} />
               ...
            </p>
            <p>
              <FaSquare size={11} color={ORANGE} style={{ marginRight: 10 }} />
               ...
            </p>
            <p>
              <FaSquare size={11} color={ORANGE} style={{ marginRight: 10 }} />
               ...
            </p>
          </div>
          <div style={{ marginLeft: 100 }}>
            <Image
              alt='moranje-logo'
              src='assets/images/security.jpg'
              // height={45}
              width={270}
              preview={false}
              style={{ objectFit: 'contain', borderRadius: 20 }}
            />
          </div>
        </div> */}

        <div className='content'>
          <h2>Modules de formation</h2>

          <div>
            {FORMATIONS.map((form, i) => (
              <span onClick={() => history.push(form.link)}>
                <FormationBox key={i} title={form.label} body={form.content} />
              </span>
            ))}
          </div>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};

const FORMATIONS = [
  {
    label: 'Définitions',
    link: ROUTES.FORMATION.DEFINITIONS,
    content: ' ...',
  },
  {
    label: 'Obligations',
    link: ROUTES.FORMATION.OBLIGATION,
    content: ' ...',
  },
  {
    label: 'Marché financiers',
    link: ROUTES.FORMATION.FINANCIER,
    content: ' ...',
  },
  {
    label: 'MoranjEtrade',
    link: ROUTES.FORMATION.MORANJE,
    content: ' ...',
  },
  {
    label: 'Marché interbancaire',
    link: ROUTES.FORMATION.INTERBANCAIRE,
    content: ' ...',
  },
  {
    label: 'Fiscalité & Compta',
    link: ROUTES.FISCA.PAGE,
    content: ' ...',
  },
  {
    label: 'Règlementation',
    link: ROUTES.REGLEMENTATION.REGION,
    content: ' ...',
  },
];
